import {makeSplitPoint} from 'plugins/react'

const AsyncReservation = makeSplitPoint(() => import('./Reservation'))

export default AsyncReservation
